import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { APDocument, DocumentFilters } from "../../types/Document";
import { PaginationResponse } from "../../types/Pagination";

export const getDossierDocuments = (
  dossierId: string,
  filters: DocumentFilters,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, pageSize, documentTypes, ...otherFilters } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["getDossierDocuments", dossierId, filters],
    queryFn: (): Promise<PaginationResponse<APDocument>> => {
      return fetchWithAuth<PaginationResponse<APDocument>>(
        "getDossierDocuments",
        dossierId,
        {
          queryParams: {
            ...otherFilters,
            accountIds: undefined,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
            documentTypes: documentTypes ? documentTypes.join(",") : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
